import { ActorInfo, ActorTypeForReconStrings } from "../recon-entity/ReconInterfaces";
/**
 * Utility interface for front end user.
 */

export enum ActorTypes {
  Admin = "Admin",
  User = "User",
}

export enum UserTypes {
  Admin = "Admin",
  User = "User",
  CustomerSuccess = "CustomerSuccess",
  Sales = "Sales",
}

export enum UserRole {
  Admin = "Admin", // User Type Admin
  Sales = "Sales", // User Type Sales
  // User Type Customer Success
  CustomerSuccessDefault = "CustomerSuccessDefault",
  RS = "RS",
  CSM = "CSM",
  KAM = "KAM",
  // User Type User
  Client = "Client",
  Maker = "Maker",
  DRMaker = "DRMaker",
  DRChecker = "DRChecker",
  DRApprover = "DRApprover",
  ReconDRApprover = "ReconDRApprover",
}
export enum ClientType {
  Product = "Product",
  ProductEnterprise = "ProductEnterprise",
  "D2C Service" = "D2C Service",
  "Service (Others)" = "Service (Others)",
  "DR Service" = "DR Service",
  POC = "POC",
  Dropped = "Dropped",
  Internal = "Internal",
  None = "None",
}

export type ClientTypeStrings = keyof typeof ClientType;

export const UserRoleUserTypeMap = {
  [UserRole.Admin]: UserTypes.Admin, // User Type Admin
  [UserRole.Sales]: UserTypes.Sales, // User Type Sales
  // User Type Customer Success
  [UserRole.CustomerSuccessDefault]: UserTypes.CustomerSuccess,
  [UserRole.RS]: UserTypes.CustomerSuccess,
  [UserRole.CSM]: UserTypes.CustomerSuccess,
  [UserRole.KAM]: UserTypes.CustomerSuccess,
  // USer Type User
  [UserRole.Client]: UserTypes.User,
  [UserRole.Maker]: UserTypes.User,
  [UserRole.DRMaker]: UserTypes.User,
  [UserRole.DRChecker]: UserTypes.User,
  [UserRole.DRApprover]: UserTypes.User,
  [UserRole.ReconDRApprover]: UserTypes.User,
};

export interface FrontendActor {
  id: number; // doesn't exist in network response
  name: string;
  actorId?: number; // actually exists in network response
  acceptedTNC: boolean;
  actorType: ActorTypes;
  integration: boolean;
  userId: number;
  actorInfo: ActorInfo;
  replyToEmail?: string;
  userType?: UserTypes;
  dynamicContents: string[];
  branchLevelReconcilation?: boolean;
  mfaEnabled?: boolean;
  mfaVerified?: boolean;
  actorName?: string;
  actorNickname?: string;
  userName?: string;
  userEmail?: string;
  workflowFeatureFlag?: boolean;
  zsMonitorAccount?: boolean;
  clientId?: number;
  crmId?: number;
  clientType?: ClientTypeStrings;
  accountType?: ActorTypeForReconStrings;
  userRole?: UserRole;
  userAgeInDays?: number;
  actorAgeInDays?: number;
  isFirstLogin?: boolean;
}

// export type NetworkFrontendActor = Omit<FrontendActor, "id"> & { actorId: number };

export enum PathType {
  "admin" = "/admin/userlist",
  "recon" = "/:accountName/recon360/Summary/Ledger",
  "bank" = "/bank/disbursement",
}
